module.exports = __webpack_public_path__ + "e8e69f41b1da2a7b6e6fcb959e00e736.woff2";